import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Home from '@/pages/Home'
import QuienesSomos from '@/pages/QuienesSomos'
import Consultas from '@/pages/Consultas'
import MedicinaPreventiva from '@/pages/MedicinaPreventiva'
import AtencionPorEspecie from '@/pages/AtencionPorEspecie'
import Cirugia from '@/pages/Cirugia'
import InternacionYCuidados from '@/pages/InternacionYCuidados'
import Enfermeria from '@/pages/Enfermeria'
import Laboratorio from '@/pages/Laboratorio'
import Dermatologia from '@/pages/Dermatologia'
import Odontologia from '@/pages/Odontologia'
import ProduccionAnimal from '@/pages/ProduccionAnimal'
import Bromatologia from '@/pages/Bromatologia'
import Bienestar from '@/pages/Bienestar'
import Cursos from '@/pages/Cursos'
import AsistenteIA from '@/pages/AsistenteIA'
import Contacto from '@/pages/Contacto'
import AdminLayout from '@/admin/AdminLayout'
import AdminLogin from '@/admin/AdminLogin'
import AdminDashboard from '@/admin/AdminDashboard'
import ContentEditor from '@/admin/ContentEditor'
import MediaManager from '@/admin/MediaManager'
import ContactSubmissions from '@/admin/ContactSubmissions'
import { useAuth } from '@/hooks/useAuth'
import { AuthProvider } from '@/contexts/AuthContext'

const ADMIN_PATHS = ['/admin', '/admin/login', '/admin/content', '/admin/media', '/admin/contact-submissions']

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isChecking } = useAuth()

  if (isChecking) {
    return <div className="min-h-screen flex items-center justify-center">Checking authentication...</div>
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />
  }

  return <>{children}</>
}

function AppContent() {
  const location = useLocation()
  const hideFooter = ADMIN_PATHS.some((path) => location.pathname === path || location.pathname.startsWith(`${path}/`))

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/quienes-somos" element={<QuienesSomos />} />
          <Route path="/consultas" element={<Consultas />} />
          <Route path="/medicina-preventiva" element={<MedicinaPreventiva />} />
          <Route path="/atencion-por-especie" element={<AtencionPorEspecie />} />
          <Route path="/cirugia" element={<Cirugia />} />
          <Route path="/internacion-y-cuidados" element={<InternacionYCuidados />} />
          <Route path="/enfermeria" element={<Enfermeria />} />
          <Route path="/laboratorio-basico" element={<Laboratorio />} />
          <Route path="/dermatologia" element={<Dermatologia />} />
          <Route path="/odontologia" element={<Odontologia />} />
          <Route path="/produccion-animal" element={<ProduccionAnimal />} />
          <Route path="/bromatologia" element={<Bromatologia />} />
          <Route path="/bienestar-y-asesoramiento" element={<Bienestar />} />
          <Route path="/cursos" element={<Cursos />} />
          <Route path="/asistente-ia" element={<AsistenteIA />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <AdminDashboard />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/content"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <ContentEditor />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/media"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <MediaManager />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/contact-submissions"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <ContactSubmissions />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {!hideFooter && <Footer />}
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
